import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'

import { DeferredRevenueWrapper } from '../../components'

export default function DeferredRevenuePage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <DeferredRevenueWrapper organization={organization} />
    </ModalProvider>
  )
}
